// extracted by mini-css-extract-plugin
export const root = "initiative-header-module--root--3pPit";
export const category = "initiative-header-module--category--VUu6i";
export const heading = "initiative-header-module--heading--3lGgs";
export const link = "initiative-header-module--link--zQ5j9";